import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { Spin } from "antd";
import {
  SESSION_AUTHENTICATED,
  SESSION_UNKNOWN,
  selectSessionStatus,
} from "../../store/slices/user";

/**
 * LF360-1970: three states, not two.
 *
 * This read `localStorage.user_token` and decided on the spot. The session is
 * an HttpOnly cookie now — the page cannot see it — so at the first render the
 * honest answer is "not known yet", and sending that to `/login` would bounce
 * every signed-in administrator out of the page they opened, for as long as the
 * session request takes. `useSession` in `App` is what resolves it.
 */
const PrivateRoutes = () => {
  const status = useSelector(selectSessionStatus);

  if (status === SESSION_UNKNOWN) {
    return (
      <div style={{ display: "flex", justifyContent: "center", padding: "80px 0" }}>
        <Spin size="large" />
      </div>
    );
  }

  return status === SESSION_AUTHENTICATED ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoutes;
